import { Checkbox } from "../components/Checkbox";
import { useId } from "react";
import { getWidgetData } from "../utils/parameters";

export const Toggle = ({className="", width, checked, onNewValue, label, labelSize, colorizeLabel, ...props}) => {
    const toggleId = useId();
    const widgetData = getWidgetData(props['data-widget-id']);
    if (widgetData) label ??= widgetData.label?.ca;

    if (label) {
        return (
            <div {...props} className="toggle-wrapper">
            <Checkbox id={toggleId} className={`${className} toggle`} checked={checked} onNewValue={onNewValue}>
                <div className="toggle-indicator"></div>
            </Checkbox>
            <label className={colorizeLabel ? "text-accent" : ""} htmlFor={toggleId} style={labelSize ? { fontSize: labelSize } : undefined}>{label}</label>
            </div>
        );
    } else {
        return (
            <Checkbox {...props} className={`${className} toggle`} checked={checked} onNewValue={onNewValue}>
                <div className="toggle-indicator"></div>
            </Checkbox>
        );
    }
};